import { put, call } from "redux-saga/effects";
// import get_api from "../../../../../lib/LockerSettings/GetApi";
import get_api from "../api/GetApi";
import { changeItemViewAction } from "../actions/index";
import { globalStartLoading, globalFinishLoading } from "modules/actions/Loading/index";

export function* getChangeItemInfoData(param) {
  try {
    yield put(globalStartLoading());
    const { data } = yield call(get_api.getViewInfo, param);

    if (data.data === null) {
      yield put(changeItemViewAction.loadChangeItemViewSuccess(false));
    } else {
      yield put(changeItemViewAction.loadChangeItemViewSuccess(data));
    }
    yield put(globalFinishLoading());
  } catch (error) {
    console.log("from saga  -> ");
    console.log(error);
    yield put(changeItemViewAction.loadChangeItemViewFail(error));
    yield put(globalFinishLoading());
  }
}
